import { CompanyPlansPage } from 'features/company/CompanyPlansPage';

export function CompanyPortalPlansPage() {
  return <CompanyPlansPage portal />;
}
